import { ArrowBackIosRoundedIcon, Flex, IconButton } from '@shared/components';

import { type AlternativeForeignerRegistrationModalLogicState } from './alternative-foreigner-registration-modal-logic';

interface AlternativeRegistrationModalLogicTitleProps {
  state: AlternativeForeignerRegistrationModalLogicState;
  onBack?: () => void;
}

export function AlternativeRegistrationModalLogicTitle(
  props: Readonly<AlternativeRegistrationModalLogicTitleProps>,
) {
  const { state, onBack } = props;

  switch (state) {
    case 'form':
    case 'error':
      return 'ลงทะเบียนด้วยเอกสารอื่น';
    case 'image-capturing':
      return (
        <Flex sx={{ gap: (theme) => theme.spacing(4) }}>
          <IconButton disableRipple onClick={onBack} sx={{ p: (theme) => theme.spacing(0) }}>
            <ArrowBackIosRoundedIcon />
          </IconButton>
          ถ่ายภาพเอกสาร
        </Flex>
      );
    case 'image-confirmation':
      return (
        <Flex sx={{ gap: (theme) => theme.spacing(4) }}>
          <IconButton disableRipple onClick={onBack} sx={{ p: (theme) => theme.spacing(0) }}>
            <ArrowBackIosRoundedIcon />
          </IconButton>
          ถ่ายภาพเอกสาร
        </Flex>
      );
    default:
      return null;
  }
}
